import { ReactNode } from 'react';
import { Anchor } from '@mantine/core';
import classes from './Link.module.css';
import clsx from 'clsx';

export const Link = (props: {
	onClick?: () => void;
	children?: ReactNode;
	color?: string;
	c?: string;
	size?: string;
	disabled?: boolean;
	underline?: 'never' | 'hover' | 'always';
}) => {
	return (
		<Anchor
			className={clsx(
				classes.link,
				props.disabled && classes.disabledLink
			)}
			{...props}
		></Anchor>
	);
};
